import { useEffect, useRef, useState } from "react";
import { Table, Modal, Button } from "antd";
import { ErrorToast } from "../../../widgets/AppToast";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";

const GeneralEnquiryList = () => {
  const calledOnce = useRef(false);

  const [loading, setLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  /* -------- Additional Info Modal State -------- */
  const [infoModal, setInfoModal] = useState({
    open: false,
    text: "",
  });

  /* ---------------- GENERAL ENQUIRY LIST API ---------------- */
  const GENERAL_ENQUIRY_LIST_API = (page = 1) => {
    setLoading(true);

    const FORM_DATA = new FormData();

    // Send page only from page 2+
    if (page > 1) {
      FORM_DATA.append("page", page);
    }

    post(ApiURL.general_enquiry_list, FORM_DATA)
      .then((res) => {
        if (res?.status === true) {
          setListData(res?.results || []);
          setTotalRecords(res?.total_records || 0);
          setCurrentPage(res?.current_page || page);
        } else {
          ErrorToast("Error", res?.message);
        }
      })
      .catch((err) => {
        console.error("General enquiry list error:", err);
      })
      .finally(() => setLoading(false));
  };

  /* ---------------- INITIAL LOAD ---------------- */
  useEffect(() => {
    if (!calledOnce.current) {
      GENERAL_ENQUIRY_LIST_API(1);
      calledOnce.current = true;
    }
  }, []);

  /* ---------------- TABLE COLUMNS ---------------- */
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      align: "center",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      align: "center",
      key: "email",
    },
    {
      title: "Contact",
      dataIndex: "phone_no",
      align: "center",
      key: "phone_no",
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      align: "center",
      key: "company_name",
      render: (val) => val || "-",
    },
    {
      title: "Enquiry Type",
      dataIndex: "inquiry_type",
      align: "center",
      key: "inquiry_type",
      render: (val) => val || "-",
    },
    {
      title: "Additional Info",
      dataIndex: "additional_info",
      align: "center",
      key: "additional_info",
      render: (text) =>
        text ? (
          <Button
            type="link"
            size="small"
            onClick={() =>
              setInfoModal({
                open: true,
                text,
              })
            }
          >
            View
          </Button>
        ) : (
          "-"
        ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      align: "center",
      key: "created_at",
      render: (val) =>
        val ? new Date(val).toLocaleString() : "-",
    },
  ];

  return (
    <div>
      <div className="row" style={{ padding: "10px" }}>
        <div className="col-6">
          <div className="theme-content-title">
            <h3>General Enquiry List</h3>
          </div>
        </div>
      </div>

      <Table
        bordered
        columns={columns}
        dataSource={listData}
        rowKey="id"
        loading={loading}
        className="custom-table"
        pagination={{
          current: currentPage,
          pageSize: 10,
          total: totalRecords,
          onChange: (page) => GENERAL_ENQUIRY_LIST_API(page),
        }}
      />

      {/* -------- Additional Info Modal -------- */}
      <Modal
        title="Additional Information"
        open={infoModal.open}
        footer={null}
        onCancel={() => setInfoModal({ open: false, text: "" })}
      >
        <div
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            maxHeight: "60vh",
            overflowY: "auto",
          }}
        >
          {infoModal.text}
        </div>
      </Modal>
    </div>
  );
};

export default GeneralEnquiryList;
